import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { Wrench } from "lucide-react";

export const MaintenanceAdmin = () => {
    const [maintenance, setMaintenance] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/settings/public")
            .then((r) => {
                setMaintenance(r.data.maintenance);
                setMessage(r.data.message);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            await api.put("/admin/settings", { maintenance, message });
            toast.success(maintenance ? "Wartungsmodus ist jetzt AN — Besucher sehen die Wartungsseite." : "Wartungsmodus ist AUS — die Website ist wieder offen.");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <p className="text-sm text-[#9C917D]">Lade Einstellungen …</p>;

    return (
        <div className="max-w-2xl" data-testid="admin-maintenance">
            <div className="rounded border border-[#2E2517] bg-[#1B150E] p-6">
                <div className="mb-4 flex items-center gap-3">
                    <Wrench size={18} className="text-[#C88A45]" />
                    <h3 className="font-display text-xl font-bold uppercase tracking-tight text-[#EDE6DA]">Wartungsmodus</h3>
                </div>
                <p className="mb-6 text-sm leading-relaxed text-[#9C917D]">
                    Wenn aktiv, sehen Besucher nur eine Wartungsseite mit Ihrer Telefonnummer — Sie selbst kommen
                    weiterhin über den Login in den Admin-Bereich und können im Hintergrund alles ändern.
                    Prüfen Sie das Ergebnis jederzeit über „Vorschau" oben rechts.
                </p>
                <label className="mb-6 flex cursor-pointer items-center gap-3 text-sm font-semibold text-[#EDE6DA]">
                    <input
                        type="checkbox"
                        data-testid="maintenance-toggle"
                        checked={maintenance}
                        onChange={(e) => setMaintenance(e.target.checked)}
                        className="h-5 w-5 accent-[#C88A45]"
                    />
                    Website vorübergehend sperren (Wartungsseite anzeigen)
                </label>
                <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-[#9C917D]">Hinweistext für Besucher</label>
                <Textarea
                    data-testid="maintenance-message"
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="mb-6 border-[#2E2517] bg-[#120E09] text-[#EDE6DA]"
                />
                <button
                    data-testid="maintenance-save"
                    onClick={save}
                    disabled={saving}
                    className={`w-full rounded-full py-3 text-sm font-bold uppercase tracking-wide transition-colors duration-200 disabled:opacity-50 ${
                        maintenance ? "bg-red-400 text-[#120E09] hover:bg-red-300" : "bg-[#C88A45] text-[#120E09] hover:bg-[#DBA057]"
                    }`}
                >
                    {saving ? "Speichern …" : maintenance ? "Wartungsmodus aktivieren" : "Einstellung speichern"}
                </button>
            </div>
        </div>
    );
};
